import themeAssets from './theme-asset'

class AppTheme {
  static defaultTheme = 'red'

  // 设置当前主题
  static setTheme(themeName = this.defaultTheme) {
    window.document.documentElement.setAttribute('data-theme', themeName)
  }

  // 获取当前主题
  static getCurrentTheme() {
    // 获取当前页面的根元素
    const rootElement = document.documentElement
    // 获取 data-theme 属性的值
    const currentTheme = rootElement.getAttribute('data-theme')
    return currentTheme || this.defaultTheme
  }

  // 获取当前主题下的静态资源
  static getThemeAsset(assetKey) {
    const curTheme = this.getCurrentTheme()
    return themeAssets[curTheme][assetKey]
  }
}

export default AppTheme
